module.exports = __webpack_public_path__ + "static/media/done.d42ad014.png";